export type CustomerDetailsContactsTranslation = {
  title: string;
};

export const customerDetailsContactsTranslation: CustomerDetailsContactsTranslation = {
  title: 'Kontakty',
};
